import { __decorate } from "tslib";
import { ArrayDecoder, AutoEncoder, DateDecoder, EnumDecoder, field, IntegerDecoder, StringDecoder } from "@simonbackx/simple-encoding";
import { v4 as uuidv4 } from "uuid";
import { Payment, PrivatePayment } from "./members/Payment";
export var BalanceItemStatus;
(function (BalanceItemStatus) {
    /**
     * The balance is not yet owed by the member (payment is optional and not visible). But it is paid, the status will change to 'paid'.
     */
    BalanceItemStatus["Hidden"] = "Hidden";
    /**
     * The balance is owed by the member, but not yet (fully) paid by the member.
     */
    BalanceItemStatus["Pending"] = "Pending";
    /**
     * The balance has been paid by the member. All settled.
     */
    BalanceItemStatus["Paid"] = "Paid";
})(BalanceItemStatus || (BalanceItemStatus = {}));
export class BalanceItem extends AutoEncoder {
    constructor() {
        super(...arguments);
        this.description = "";
        this.price = 0;
        this.pricePaid = 0;
        this.createdAt = new Date();
        this.status = BalanceItemStatus.Pending;
    }
    get isPaid() {
        return this.pricePaid === this.price;
    }
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], BalanceItem.prototype, "id", void 0);
__decorate([
    field({ decoder: StringDecoder })
], BalanceItem.prototype, "description", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], BalanceItem.prototype, "price", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], BalanceItem.prototype, "pricePaid", void 0);
__decorate([
    field({ decoder: DateDecoder })
], BalanceItem.prototype, "createdAt", void 0);
__decorate([
    field({ decoder: new EnumDecoder(BalanceItemStatus) })
], BalanceItem.prototype, "status", void 0);
export class BalanceItemPayment extends AutoEncoder {
}
__decorate([
    field({ decoder: StringDecoder, defaultValue: () => uuidv4() })
], BalanceItemPayment.prototype, "id", void 0);
__decorate([
    field({ decoder: IntegerDecoder })
], BalanceItemPayment.prototype, "price", void 0);
export class MemberBalanceItemPayment extends BalanceItemPayment {
}
__decorate([
    field({ decoder: Payment })
], MemberBalanceItemPayment.prototype, "payment", void 0);
export class BalanceItemPaymentWithPrivatePayment extends BalanceItemPayment {
}
__decorate([
    field({ decoder: PrivatePayment })
], BalanceItemPaymentWithPrivatePayment.prototype, "payment", void 0);
export class BalanceItemWithPayments extends BalanceItem {
    constructor() {
        super(...arguments);
        this.payments = [];
    }
    updatePricePaid() {
        this.pricePaid = this.payments.reduce((total, payment) => total + (payment.payment.isSucceeded ? payment.price : 0), 0);
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(MemberBalanceItemPayment) })
], BalanceItemWithPayments.prototype, "payments", void 0);
export class BalanceItemWithPrivatePayments extends BalanceItem {
    constructor() {
        super(...arguments);
        this.payments = [];
    }
    updatePricePaid() {
        this.pricePaid = this.payments.reduce((total, payment) => total + (payment.payment.isSucceeded ? payment.price : 0), 0);
    }
}
__decorate([
    field({ decoder: new ArrayDecoder(BalanceItemPaymentWithPrivatePayment) })
], BalanceItemWithPrivatePayments.prototype, "payments", void 0);
//# sourceMappingURL=BalanceItem.js.map